import {css} from 'lit';
export const styles = css`:host {
  --background: var(--contrast-light);
  --font: var(--font-size-sm);
  --link-text-hover: var(--dark-text-secondary);
  --link-text-active: var(--dark-text-secondary);

  display: block;
}

a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font);
  color: var(--dark-text-secondary);
  line-height: 1.2;
  background-color: var(--background);
  border-radius: var(--border-radius);
  padding: 16px;
}

ef-img-placeholder {
  --element-size: 60px;

  margin-right: 16px;
  flex-shrink: 0;
}

.content {
  display: flex;
  align-items: center;
}

.info > div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-wrap: break-word;
    margin-bottom: 8px;
  }

slot[name='name'] {
  color: var(--dark-text);
  font-weight: 700;
}

.status {
  display: flex;
  margin-left: 16px;
  background-color: var(--primary);
  padding: 6px;
  border-radius: 50%;
}

.read .status {
  background-color: transparent;
}

@media (hover: hover) {
  a:hover {
    --background: var(--gray-200);
  }
}

:host a:active {
  --background: var(--gray-300);
}

/* TO-DO: add style for Permanent notification when design is ready */
`;
export default styles;
